import classNames from "classnames";
import React from "react";
import { useSelector } from "react-redux";
import { ReactComponent as IndahashLogo } from "../../images/indahash-full.svg";

export function ShowcaseSeparator(props) {
  const {
    className,
    id,
    primaryColor,
    renderProviderIcon,
    provider,
    creatorName,
    hideInfo,
    printing,
  } = props;

  const showcaseTitle = useSelector(
    (state) => state.showcaseReducer.showcaseTitle,
  );

  const identity = useSelector((state) => state.mainReducer.identity);

  return (
    <div
      id={id}
      key={id}
      className={classNames("showcase-template__separator", className)}
    >
      {!hideInfo && (
        <div className="showcase-template__separator__info">
          <span>
            {identity?.wsWorkspace?.name}
            &nbsp;✦&nbsp;
            {showcaseTitle}
          </span>
          <span>#</span>
        </div>
      )}

      {primaryColor && (
        <div
          className="showcase-template__separator-colored-line"
          style={{ backgroundColor: primaryColor }}
        />
      )}

      <div
        className={classNames("showcase-template__separator-line", {
          "showcase-template__separator-line--hidden": printing,
        })}
      />

      {provider !== "last" ? (
        <>
          {renderProviderIcon && (
            <div className="showcase-template__separator-provider">
              {renderProviderIcon(provider)}
              {creatorName}
            </div>
          )}

          <div className="showcase-template__separator-campaign-logo">
            {identity?.wsWorkspace?.logo ? (
              <img src={identity.wsWorkspace.logo} alt="logo" />
            ) : (
              <IndahashLogo />
            )}
          </div>
        </>
      ) : null}
    </div>
  );
}
